import PropTypes from 'prop-types';

export default PropTypes.shape({
    cronExpression: PropTypes.string,
    cronDescription: PropTypes.string,
    enabled: PropTypes.bool,
    allowedServerNames: PropTypes.string
})